export interface SizesState {
  headerHeight: number;
  windowHeight: string;
  windowWidth: number;
  categoriesHeight: number;
  categoriesHeightIds: number[];
  servicesHeight: number;
  tizerHeight: number;
  maxHeight: number;
}

export const SET_HEADER_HEIGHT = 'SET_HEADER_HEIGHT';
export const SET_WINDOW_HEIGHT = 'SET_WINDOW_HEIGHT';
export const SET_WINDOW_WIDTH = 'SET_WINDOW_WIDTH';
export const RESET_CATEGORIES_HEIGHT = 'RESET_CATEGORIES_HEIGHT';
export const SET_CATEGORY_HEIGHT = 'SET_CATEGORY_HEIGHT';
export const SET_SERVICES_HEIGHT = 'SET_SERVICES_HEIGHT';
export const SET_TIZER_HEIGHT = 'SET_TIZER_HEIGHT';

interface SetHeaderHeight {
  type: typeof SET_HEADER_HEIGHT;
  payload: number;
}

interface SetWindowHeight {
  type: typeof SET_WINDOW_HEIGHT;
  payload: string;
}

interface SetWindowWidth {
  type: typeof SET_WINDOW_WIDTH;
  payload: number;
}

interface SetServicesHeight {
  type: typeof SET_SERVICES_HEIGHT;
  payload: number;
}

interface SetTizerHeight {
  type: typeof SET_TIZER_HEIGHT;
  payload: number;
}

interface SetCategoryHeight {
  type: typeof SET_CATEGORY_HEIGHT;
  height: number;
  id: number;
}

interface ResetCategoriesHeight {
  type: typeof RESET_CATEGORIES_HEIGHT;
}

export type SizesActionTypes =
  | SetHeaderHeight
  | SetWindowHeight
  | SetWindowWidth
  | SetServicesHeight
  | ResetCategoriesHeight
  | SetTizerHeight
  | SetCategoryHeight;
